import { Box, Stack, Typography, useTheme } from '@mui/material'
import { memo } from 'react'
import { blueFull, greenFull, redFull } from '../../pages/home/plChart'

const PayoffLegends = () => {
    const theme = useTheme()
    return (
        <Stack spacing={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ width: '100%' }}>
            <Stack spacing={2} direction={'row'} alignItems={'center'}>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box style={{ width: '20px', borderRadius: '2px', height: '4px', background: `linear-gradient( 90deg,${greenFull} 50%, ${redFull} 50% )` }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        ON EXPIRY
                    </Typography>
                </Stack>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box style={{ width: '20px', borderRadius: '2px', height: '4px', background: blueFull }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        ON TARGET DAY
                    </Typography>
                </Stack>
            </Stack>
            <Stack spacing={2} direction={'row'} alignItems={'center'}>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box sx={{ background: theme.palette.call.main, borderRadius: '2px', height: '16px', width: '4px' }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        CE OI
                    </Typography>
                </Stack>
                <Stack spacing={1} direction={'row'} alignItems={'center'}>
                    <Box sx={{ background: theme.palette.put.main, borderRadius: '2px', height: '16px', width: '4px' }} />
                    <Typography fontSize={10} color={'text.secondary'}>
                        PE OI
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default memo(PayoffLegends)
